<template>
  <div>
    <!--banner-->
    <div class="product_page_banner_out">
      <div class="container">
        <dl class="all_page_banner_txt">
          <dt>产品中心</dt>
          <dd>Product &nbsp;&nbsp; Center</dd>
        </dl>
      </div>
    </div>
    <!--banner  end-->
    <!--内容-->
    <div class="product_page_sort_out">
      <div class="container">
        <div class="row">
          <div class="product_page_sort">
            <span class="title">产品分类：</span>
            <div class="sort_list">
              <a
                v-for="typeitem in typeList"
                @click="openmenu(typeitem)"
                :class="typeitem.Selected ? 'active' : ''"
                >{{ typeitem.title }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="clearfix" style="margin-top: 20px">
      <div class="all_page_con_out fr">
        <div class="product_page_sort_con">
          <div class="container">
            <div class="row">
              <div class="product_page_list2 clearfix">
                <h4 class="product_page_list2_out_title">{{ parentTitle }}</h4>

                <div>
                  <div class="product_page_list2_con_title">
                    <div class="title" v-for="item in contentTxt">
                      <!--<div  v-html="{{item}}"></div>-->
                      <h6>{{ item.name }}</h6>
                    </div>
                  </div>
                </div>

                <!--原先的-->
                <div v-for="item in currList">
                  <div class="product_page_list2_con_title">
                    <div class="title">
                      <h6>{{ item.title }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--内容  end-->
  </div>
</template>


<script>
import "../../static/css/swiper.min.css";
import "../../static/css/nav.css";
import "../../static/css/bootstrap.min.css";
import "../../static/css/animate.min.css";
import "../../static/css/common.css";
import "../../static/css/style.css";
import axios from "@/libs/api.request";

export default {
  data() {
    return {
      parentTitle: "",
      //当前页码
      PagaIndex: 1,
      //每页数量
      pageSize: 12,
      //总记录数
      totalcount: 0,
      EnCode: "",
      typeList: [
        {
          parentId: 3046,
          enCode: "ClinicalHematology",
          title: "临床血液学形态",
          icon: null,
          coverImg:
            "/img/zzpt/2fcac359-d518-4a8d-a4c2-9cc1019af0b4201904120837145885.jpg",
          urlAddress: null,
          sortCode: 1,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-05-12T10:14:24.2",
          createUserId: null,
          modifyDate: "2021-01-05T16:37:51.993",
          modifyUserId: "0",
          children: null,
          id: 3047,
        },
        {
          parentId: 3046,
          enCode: "BasicClinicalExamination",
          title: "临床基础检验技术",
          icon: null,
          coverImg:
            "/img/zzpt/8e865034-e793-40ec-bad4-b4c9802f43d3201904120835595729.jpg",
          urlAddress: null,
          sortCode: 2,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-05-12T10:15:51.053",
          createUserId: null,
          modifyDate: "2021-01-05T16:40:13.147",
          modifyUserId: "0",
          children: null,
          id: 3048,
        },
        {
          parentId: 3046,
          enCode: "ClinicalPeripheralBlood",
          title: "临床外周血形态",
          icon: null,
          coverImg: "/img/zzpt/c5a98ff1-394a-4276-80e6-0964d0b9a44fwaizhou.png",
          urlAddress: null,
          sortCode: 3,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-12-29T15:43:12.217",
          createUserId: null,
          modifyDate: "2021-01-05T16:44:03.64",
          modifyUserId: "0",
          children: null,
          id: 6099,
        },
        {
          parentId: 3046,
          enCode: "menu8140",
          title: "临床寄生虫检验技术",
          icon: null,
          coverImg: "/img/zzpt/e7933a6d-479f-4723-bb5b-1eff7bcb8a959696.png",
          urlAddress: null,
          sortCode: 4,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-05T13:44:32.227",
          createUserId: null,
          modifyDate: "2021-02-05T13:56:50.907",
          modifyUserId: "0",
          children: null,
          id: 8140,
        },
        {
          parentId: 3046,
          enCode: "menu8141",
          title: "临床微生物检验技术",
          icon: null,
          coverImg:
            "/img/zzpt/7d0312cd-f0d3-4f74-90e1-5e8a5b8c480f202005231709304884.png",
          urlAddress: null,
          sortCode: 5,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-05T13:45:00.72",
          createUserId: null,
          modifyDate: "2021-05-12T15:06:29.24",
          modifyUserId: "0",
          children: null,
          id: 8141,
        },
        {
          parentId: 3046,
          enCode: "MedicalScienceVirtualexperiment",
          title: "医学检验虚拟实验",
          icon: null,
          coverImg:
            "/img/zzpt/b87810c4-45d5-4e80-8719-43c247ea1e99201805102131404433.jpg",
          urlAddress: "vir",
          sortCode: 6,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-12-29T15:26:36.73",
          createUserId: null,
          modifyDate: "2021-02-05T13:57:01.197",
          modifyUserId: "0",
          children: null,
          id: 6098,
        },
        {
          parentId: 3046,
          enCode: "OralTechnology",
          title: "口腔技术虚拟实验",
          icon: null,
          coverImg:
            "/img/zzpt/db8331f2-2443-44a3-87a4-daef9df347e2201805102132530409.jpg",
          urlAddress: "vir",
          sortCode: 7,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-12-29T15:44:36.287",
          createUserId: null,
          modifyDate: "2021-02-05T13:57:08.137",
          modifyUserId: "0",
          children: null,
          id: 6100,
        },
        {
          parentId: 3046,
          enCode: "PublicHealth",
          title: "公共卫生与预防医学",
          icon: null,
          coverImg:
            "/img/zzpt/025b55c7-cd47-4a1c-8682-a9b6562c3132201905061158043100.jpg",
          urlAddress: "vir",
          sortCode: 9,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-12-29T15:47:33.5",
          createUserId: null,
          modifyDate: "2021-02-08T11:00:20.947",
          modifyUserId: "0",
          children: null,
          id: 6102,
        },
        {
          parentId: 3046,
          enCode: "menu28292",
          title: "基础实验系列",
          icon: null,
          coverImg:
            "/img/zzpt/c2cf856f-afba-498a-ad66-a0c27370d98e202101071439062026.jpg",
          urlAddress: "vir",
          sortCode: 10,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:30:30.917",
          createUserId: null,
          modifyDate: "2021-02-08T11:00:27.293",
          modifyUserId: "0",
          children: null,
          id: 28292,
        },
        {
          parentId: 3046,
          enCode: "menu28293",
          title: "实验室安全系统",
          icon: null,
          coverImg:
            "/img/zzpt/0ce61f8d-1bc3-41e7-bb5d-7e5ff30927f3202101071440454681.png",
          urlAddress: "vir",
          sortCode: 11,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:32:19.923",
          createUserId: null,
          modifyDate: "2021-02-08T11:00:32.347",
          modifyUserId: "0",
          children: null,
          id: 28293,
        },
        {
          parentId: 3046,
          enCode: "menu28294",
          title: "English",
          icon: null,
          coverImg:
            "/img/zzpt/3326ea07-d414-4aa5-a000-a67858ef395b202010141448393288.png",
          urlAddress: "vir",
          sortCode: 12,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:33:37.37",
          createUserId: null,
          modifyDate: "2021-02-08T11:00:36.997",
          modifyUserId: "0",
          children: null,
          id: 28294,
        },
        {
          parentId: 3046,
          enCode: "menu28295",
          title: "眼视光医学虚拟实验",
          icon: null,
          coverImg:
            "/img/zzpt/35993f9f-4ad4-4eb2-bca4-00bffa68af65202002121003579890.jpg",
          urlAddress: "vir",
          sortCode: 12,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:34:44.53",
          createUserId: null,
          modifyDate: "2021-02-07T11:43:03.917",
          modifyUserId: "0",
          children: null,
          id: 28295,
        },
        {
          parentId: 3046,
          enCode: "menu28296",
          title: "康复医学虚拟实验",
          icon: null,
          coverImg:
            "/img/zzpt/8852eb5e-c43e-4d2c-9ab6-3bf33a44d171202002181340355479.jpg",
          urlAddress: "vir",
          sortCode: 13,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:35:52.28",
          createUserId: null,
          modifyDate: "2021-02-07T11:43:09.877",
          modifyUserId: "0",
          children: null,
          id: 28296,
        },
        {
          parentId: 3046,
          enCode: "menu28297",
          title: "诊断听力学虚拟实验",
          icon: null,
          coverImg:
            "/img/zzpt/a8de7cd3-5b97-43ed-bda0-e692bd7c279c202002121007588506.jpg",
          urlAddress: "vir",
          sortCode: 14,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-07T11:38:37.923",
          createUserId: null,
          modifyDate: "2021-02-07T11:43:16.1",
          modifyUserId: "0",
          children: null,
          id: 28297,
        },
        {
          parentId: 3046,
          enCode: "menu28298",
          title: "其它实验",
          icon: null,
          coverImg:
            "/img/zzpt/94c677d3-da3f-4901-906d-ecf911df084f202004270848030609.jpg",
          urlAddress: "vir",
          sortCode: 15,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-02-08T10:58:53.497",
          createUserId: null,
          modifyDate: "2021-02-18T09:18:47.397",
          modifyUserId: "0",
          children: null,
          id: 28298,
        },
        {
          parentId: 3046,
          enCode: "menu12280",
          title: "微课视频",
          icon: null,
          coverImg: "/img/zzpt/2954f394-eb0a-4026-8319-241ae10a7ca9aaa.jpg",
          urlAddress: "video",
          sortCode: 16,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-12-29T15:53:51.37",
          createUserId: null,
          modifyDate: "2021-02-08T10:59:17.973",
          modifyUserId: "0",
          children: null,
          id: 12280,
        },
        {
          parentId: 3046,
          enCode: "Exam",
          title: "考试系统",
          icon: null,
          coverImg: "/img/zzpt/33913666-59a0-4c53-bc11-226602a43c13321.png",
          urlAddress: "Exam",
          sortCode: 17,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2020-11-11T17:24:27.13",
          createUserId: null,
          modifyDate: "2021-02-08T10:59:34.847",
          modifyUserId: "0",
          children: null,
          id: 6090,
        },
        {
          parentId: 3046,
          enCode: "切片系统",
          title: "切片系统",
          icon: null,
          coverImg: "/img/zzpt/18ac2c5b-c238-4765-800b-6857614a1059骨髓片.jpg",
          urlAddress: "DigitalSlides",
          sortCode: 18,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-01-04T13:17:08.717",
          createUserId: null,
          modifyDate: "2021-06-21T09:15:11.467",
          modifyUserId: "0",
          children: null,
          id: 6115,
        },
        {
          parentId: 3046,
          enCode: "chanpin",
          title: "产品介绍",
          icon: null,
          coverImg: "/img/zzpt/123.jpg",
          urlAddress: "video",
          sortCode: 99,
          isDeleted: 0,
          enabledMark: 1,
          description: null,
          createDate: "2021-11-02T17:38:50.593",
          createUserId: null,
          modifyDate: null,
          modifyUserId: null,
          children: null,
          id: 56056,
        },
      ],
      currList: [],
      title: "",
      id: 0,
      neirong1: false, //内容1是否展示
      contentTxt: [],
      neirong2: false, //内容2是否展示
    };
  },
  methods: {
    //当页码变化
    //分页
    change(page) {
      this.PagaIndex = page;
      this.getData();
    },
    getType() {
      // var posturl = this.config.baseUrl.pro + "/Login/apiGetRoleCurrs";
      // axios
      //   .request({
      //     url: posturl,
      //     method: "post",
      //     changeOrigin: true, //允许跨域
      //     data: { encode: this.EnCode },
      //   })
      //   .then((resp) => {
      //     if (resp.status === 200) {
      //       var list = resp.data.result;
      //       this.typeList = list;
      //       console.log(this.typeList);
      //       if (this.id == undefined || this.id == "undefined") {
      //         if (this.typeList != undefined && this.typeList.length > 0) {
      //           this.openmenu(this.typeList[0]);
      //         }
      //       } else {
      //         for (var s = 0; s < this.typeList.length; s++) {
      //           this.typeList[s].Selected = false;
      //           if (this.typeList[s].id == this.id) {
      //             this.typeList[s].Selected = true;
      //             this.openmenu(this.typeList[s]);
      //             // break;
      //           }
      //         }
      //       }
      //     }
      //   })
      //   .catch((err) => {
      //     this.$Message.error("数据删除失败：" + err);
      //   });
    },
    getData(EnCode) {
      var posturl = this.config.baseUrl.pro + "/Login/apiGetRoleCurrs";
      axios
        .request({
          url: posturl,
          method: "post",
          changeOrigin: true, //允许跨域
          data: { encode: EnCode },
        })
        .then((resp) => {
          if (resp.status === 200) {
            var list = resp.data.result;
            console.log(list);
            for (var s = 0; s < list.length; s++) {
              if (list[s].coverImg.indexOf("http:") < 0) {
                list[s].coverImg =
                  "http://" + window.location.host + list[s].coverImg;
              }
            }
            this.currList = list;
          }
        })
        .catch((err) => {
          this.$Message.error("数据删除失败：" + err);
        });
    },
    //数据加载
    openmenu(item) {
      // alert(item.id);
      // this.this.contentTxt=[];
      this.parentTitle = item.title;
      this.id = item.id;
      this.title = item.title;
      for (var s = 0; s < this.typeList.length; s++) {
        this.typeList[s].Selected = false;
        if (this.typeList[s].id == this.id) {
          this.typeList[s].Selected = true;
        }
      }
      if (item.id == 3047) {
        this.currList = [];
        this.contentTxt = [
          { name: "临床血液形态学-标本资源库" },
          { name: "临床血液形态学-微课堂" },
          { name: "临床血液形态学-临床案例" },
        ];
        return true;
      }
      if (item.id == 3048) {
        this.currList = [];
        this.contentTxt = [
          { name: "临床基础检验技术-标本资源库" },
          { name: "临床基础检验技术-微课堂" },
          { name: "临床基础检验技术-临床案例" },
        ];
        return true;
      }
      if (item.id == 6099) {
        this.currList = [];
        this.contentTxt = [
          { name: "临床外周血形态-标本资源库" },
          { name: "临床外周血形态-微课堂" },
          { name: "临床外周血形态-临床案例" },
        ];
        return true;
      }
      if (item.id == 8140) {
        this.currList = [];
        this.contentTxt = [
          { name: "临床寄生虫检验技术-标本资源库" },
          { name: "临床寄生虫检验技术-微课堂" },
          { name: "临床寄生虫检验技术-临床案例" },
        ];
        return true;
      }
      if (item.id == 8141) {
        this.currList = [];
        this.contentTxt = [
          { name: "临床微生物检验技术-标本资源库" },
          { name: "临床微生物检验技术-微课堂" },
          { name: "临床微生物检验技术-临床案例" },
        ];
        return true;
      }
      if (item.id == 6098) {
        this.currList = [];
        this.contentTxt = [
          { name: "分子诊断学综合实训系统" },
          { name: "人乳头瘤状病毒HPV分型检测" },
          { name: "新型冠状病毒肺炎诊疗及实验室诊断" },
          { name: "凝血分析测定" },
          { name: "BSL-2实验室中Ⅱ型单纯疱疹病毒灭活疫苗的制备" },
          { name: "3500遗传测序仪的结构展示仿真实验" },
          { name: "噬菌体治疗耐药菌感染的微观机制" },
          { name: "全自动生化分析仪" },
          { name: "红细胞ABO血型鉴定Rh血型系统的鉴定" },
          { name: "全自动酶免分析仪" },
          { name: "全自动化学发光分析仪虚拟实验系统" },
          { name: "双抗原夹心ELISA法检测HIV抗体" },
          { name: "虚拟临床检验科基本技能训练系统" },
          { name: "ELISA法检测血清中乙肝病毒表面抗体" },
          { name: "3H-TdR掺入实验测定淋巴细胞增殖状态" },
          { name: "血气分析仪" },
          { name: "临床细菌学检查综合实验虚拟仿真软件" },
          { name: "蓝白斑实验筛选重组子" },
          { name: "皮肤采血暨疟原虫检查-厚薄血膜的制作与染色" },
          { name: "药敏实验" },
          { name: "兔多克隆抗体制备及Western Blot鉴定虚拟仿真教学" },
          { name: "放射免疫分析法测定血清激素含量" },
          { name: "血涂片的制备与染色" },
          { name: "RT-qPCR检测细胞内RNA表达(荧光定量PCR)" },
          { name: "HIV感染免疫诊断虚拟仿真实验" },
          { name: "幽门螺杆菌的致病机制和诊断方法" },
          { name: "超敏C-反应蛋白试剂盒的制备" },
          { name: "血清葡萄糖测定" },
          { name: "DNA片段的连接与回收" },
          { name: "质粒DNA的提取与浓度的检测" },
          { name: "琼脂糖凝胶电泳" },
          { name: "间接荧光免疫法检测ANA" },
          { name: "荧光定量PCR(TaqMan探针法)虚拟仿真教学" },
          { name: "布鲁菌的检验虚拟仿真实验" },
          { name: "血液细胞分析仪虚拟仿真实验" },
          { name: "急性白血病MICM的分型诊断" },
          { name: "输血前交叉配血虚拟实验" },
          { name: "线性范围及评价虚拟实验" },
          { name: "速率法测定谷丙转氨酶活性" },
          { name: "尿液自动化分析虚拟仿真实验" },
          { name: "手足口病病毒的分离与检测" },
          { name: "双缩脲法测定血清总蛋白" },
          { name: "葡萄糖氧化酶测定血糖" },
          { name: "甲型流感病毒检测虚拟仿真教学软件" },
          { name: "免疫细胞治疗细胞制品质控流式检测实验" },
          { name: "非淋菌性尿道炎病原体感染诊断的虚拟仿真实验" },
          { name: "甲胎蛋白全自动电化学发光分析仪虚拟实验系统" },
          { name: "DNA亲权鉴定虚拟仿真实验系统" },
          { name: "革兰染色" },
          { name: "PCR-导流杂交法检测耳聋易感基因" },
          { name: "血源性感染葡萄球菌的检验虚拟仿真实验" },
          { name: "尿液标本的细菌学检验虚拟仿真实验" },
          { name: "不明原因发热病原菌检验思路与质量保证" },
          { name: "单克隆抗体制备虚拟仿真实验" },
          {
            name: "人乳头瘤病毒（反向斑点杂交法、荧光定量法）感染的分子生物学诊断虚拟实验",
          },
          { name: "脑膜炎奈瑟菌和淋病奈瑟菌临床检验训练" },
          { name: "全自动药敏分析仪" },
          { name: "半自动生化分析仪虚拟仿真教学软件" },
          { name: "缺失性-α地中海贫血基因检测虚拟仿真教学" },
          { name: "白血病遗传学分型虚拟仿真实验" },
          { name: "DIC及相关实验室检查虚拟仿真项目" },
          { name: "CYP2C19基因检测" },
          { name: "临床实验室虚拟仿真平台" },
          { name: "霍乱弧菌检测与防控虚拟仿真实验" },
          { name: "病原体RNA的定量检测--丙型肝炎病毒虚拟仿真教学" },
          { name: "血红蛋白电泳" },
          { name: "PD-1抗体制备及检测应用的虚拟仿真实验" },
          { name: "高传染性冠状病毒核酸分子检测的虚拟仿真实验" },
          { name: "紫外法总蛋白测定" },
          { name: "白细胞分类计数" },
          { name: "全自动血液细胞分析仪虚拟仿真教学系统（英文）" },
          { name: "高效价兔抗绵阳红细胞抗体的制备与检测" },
          { name: "结核分枝杆菌" },
          { name: "TPPA法检测梅毒特异性抗体" },
          { name: "血液标本采集" },
          { name: "白细胞计数（改良版牛鲍计数板）" },
          { name: "血细胞计数板计数Web（中文）" },
          { name: "基于流式细胞术的中药对免疫细胞功能影响的虚拟仿真实验" },
          { name: "人血浆蛋白质实验室检测" },
          { name: "电解质检测虚拟实验" },
          { name: "新冠病毒核酸检测虚拟仿真实验" },
          { name: "常规生化测定虚拟实验" },
          { name: "全自动生化分析仪（日立7180）" },
          { name: "全自动生化分析仪(罗氏702)" },
          { name: "虚拟检验科" },
          { name: "小鼠精子畸形实验" },
          { name: "干扰实验" },
          { name: "回收实验" },
          { name: "血清直接胆红素浓度测定" },
        ];
        return true;
      }
      if (item.id == 6100) {
        this.currList = [];
        this.contentTxt = [
          { name: "上牙槽后神经阻滞麻醉术" },
          { name: "下颌第一磨牙开髓揭顶术" },
          { name: "X线头影测量" },
          { name: "上颌第一前磨牙开髓揭顶术" },
          { name: "上颌中切牙开髓揭顶术" },
          { name: "手动器械根管预备技术" },
          { name: "G.V.Black II类洞制备术" },
          { name: "机用镍钛根管预备技术" },
          { name: "热牙胶根管充填法" },
          { name: "上颌第一磨牙开髓揭顶术" },
          { name: "上颌牙槽脓肿切开引流术" },
          { name: "冷牙胶侧方加压法" },
          { name: "下牙槽神经阻滞麻醉术" },
          { name: "单颌牙弓夹板固定术" },
          { name: "托槽粘接技术" },
          { name: "龈下刮治术" },
          { name: "下颌磨牙窝沟封闭术" },
          { name: "上牙列印模制取技术" },
          { name: "后牙铸造全冠牙体预备" },
          { name: "牙槽突修整术" },
          { name: "下牙列印模制取技术" },
          { name: "牙体缺损修复虚拟仿真教学体系之全瓷冠教学软件" },
          { name: "前牙烤瓷熔附金属全冠牙体预备技术" },
          { name: "全口义齿虚拟仿真实训系统" },
          { name: "上颌中切牙拔除术" },
          { name: "下颌阻生智齿拔除术" },
          { name: "巴斯刷牙法" },
        ];
        return true;
      }
      if (item.id == 6102) {
        this.currList = [];
        this.contentTxt = [
          { name: "虚拟理化实验室" },
          { name: "流式细胞术检测细胞凋亡实验" },
          { name: "工作环境中粉尘含量检测虚拟实验仿真教学软件" },
          { name: "空气中二氧化硫检测虚拟实验" },
          { name: "气相色谱-串联质谱联用仪检测食物中的农药残留虚拟实验" },
          { name: "地表水水样采集技术" },
          { name: "化学物对大小鼠毒性作用研究虚拟仿真实验" },
          { name: "液相色谱-串联质谱联用仪虚拟操作" },
          { name: "有机磷食物中毒应急处置虚拟仿真实验" },
          { name: "办公场所甲醛采集虚拟实验" },
          { name: "职业性有害因素的识别与控制（以蓄电池生产行业为例）" },
          { name: "职业中毒中空气检测虚拟综合实验--汞的检测与应用" },
          { name: "公共用品微生物的采样方法" },
          { name: "突发性水污染事件应急处置案例虚拟仿真教学软件3D版" },
          { name: "鼻咽拭子采样虚拟仿真实验" },
          { name: "散装食品采样虚拟仿真教学软件" },
          { name: "医务人员手术室职业暴露防护" },
          { name: "食物中毒" },
          {
            name: "蔬菜中铅、镉、锰、铝、铬、镍、铜、钒、锡的含量测定_样品分析",
          },
          { name: "洪涝灾害卫生应急演练虚拟仿真平台" },
          { name: "高效液相色谱仪测定饮料中的咖啡因（手动进样）虚拟实验" },
          { name: "细菌性食物中毒应急处理虚拟仿真实验" },
          { name: "急性胃肠炎（诺如）疫情监测虚拟仿真实验" },
        ];
        return true;
      }
      if (item.id == 28292) {
        this.currList = [];
        this.contentTxt = [
          { name: "静脉采血虚拟仿真教学" },
          { name: "高效液相色谱仪自动进样" },
          { name: "三区划线-细菌分离技术" },
          { name: "移液枪的使用" },
          { name: "血清倍比稀释" },
          { name: "光学显微镜结构与使用" },
          { name: "离心机的使用虚拟仿真实验" },
          { name: "生物安全柜的使用虚拟实验" },
        ];
        return true;
      }
      if (item.id == 28293) {
        this.currList = [];
        this.contentTxt = [
          { name: "防护服的穿戴" },
          { name: "实验室触电急救与处理" },
          { name: "生物实验室应急演练" },
          { name: "实验室火灾处置应急演练" },
          { name: "P3实验室防护规范虚拟仿真教学实验" },
          { name: "P2实验室防护规范虚拟实验" },
        ];
        return true;
      }
      if (item.id == 28294) {
        this.currList = [];
        this.contentTxt = [
          { name: "Blood count board" },
          {
            name: "Automatic blood cell analyzer virtual simulation teaching system",
          },
          { name: "Automation test Virtual simulation experiment of urine" },
          { name: "Virtual clinical laboratory roaming learning platform" },
          { name: "LABORATORY TESTS FOR SYPHILIS" },
        ];
        return true;
      }
      if (item.id == 28295) {
        this.currList = [];
        this.contentTxt = [
          { name: "弧形视野计" },
          { name: "同视机的使用" },
          { name: "渐变镜的验配" },
          { name: "配镜核心技术虚拟仿真实验-接待客户" },
          { name: "视觉训练虚拟仿真实验" },
          { name: "配镜核心技术虚拟仿真实验-瞳距测量" },
          { name: "配镜核心技术虚拟仿真实验-试镜" },
          { name: "双眼视觉检查虚拟仿真实验" },
          { name: "软性接触镜的护理与佩戴" },
          { name: "镜片加工虚拟仿真实验" },
          { name: "眼底照相机" },
          { name: "多功能色觉对比敏感度仪" },
        ];
        return true;
      }
      if (item.id == 28296) {
        this.currList = [];
        this.contentTxt = [
          { name: "COPD康复训练" },
          { name: "脊髓损伤康复训练" },
          { name: "手外伤作业治疗虚拟仿真软件" },
          { name: "徒手肌力检查MMT" },
          { name: "三维人体解剖" },
        ];
        return true;
      }
      if (item.id == 28297) {
        this.currList = [];
        this.contentTxt = [
          { name: "耳蜗电图虚拟仿真实验" },
          { name: "良性阵发性位置性眩晕的评估和康复" },
          { name: "小儿听力损失的干预虚拟仿真项目" },
          { name: "听障儿童言语障碍的康复虚拟仿真项目" },
          { name: "纯音测听虚拟仿真系统" },
        ];
        return true;
      }
      if (item.id == 28298) {
        this.currList = [];
        this.contentTxt = [
          { name: "基础医学--原发性肺结核的鉴定与诊断" },
          { name: "基础医学--缺血性脑卒中形态学虚拟仿真实验" },
          { name: "法医--高坠伤虚拟仿真实验" },
          { name: "护理学--阴道助产术虚拟仿真实验教学系统" },
          { name: "药学--阿司匹林原料药的红外鉴别" },
          { name: "药学--黄连中黄连素的提取、分离及含量测定" },
          { name: "药学--发酵罐的使用及发酵过程检测" },
          { name: "核医学--医用电子直线加速器大部件装配虚拟仿真实验" },
          {
            name: "核医学--氟-18放射性探针的制备及其小动物正电子发射成像虚拟仿真实验教学项目",
          },
          { name: "核医学--磷屏放射自显影显像" },
          { name: "微生物学--HBV的抗原抗体系统" },
        ];
        return true;
      }
      if (item.id == 12280) {
        this.currList = [];
        this.contentTxt = [
          // {name:'基础医学 -- 生理学 -- 肺换气'},
          // {name:'基础医学 -- 生理学 -- 神经-肌肉接头处兴奋传递'},
          // {name:'基础医学 -- 生理学 -- 静息电位'},
          // {name:'基础医学 -- 生理学 -- 肾小球过滤'},
          // {name:'基础医学 -- 生理学 -- 月经周期'},
          // {name:'基础医学 -- 病理学 -- 肉芽组织'},
          // {name:'基础医学 -- 病理学 -- 门脉性肝硬化的临床病理联系'},
          // {name:'基础医学 -- 病理学 -- 血液循环途径'},
          // {name:'基础医学 -- 病理学 -- 肿瘤的生长方式'},
          // {name:'基础医学 -- 解剖学 -- 肺的组成及形态'},
          // {name:'基础医学 -- 解剖学 -- 骨盆的组成'},
          // {name:'基础医学 -- 解剖学 -- 脑的动脉血管'},
          // {name:'基础医学 -- 解剖学 -- 栓子的运行途径'},
          // {name:'基础医学 -- 解剖学 -- 心脏的瓣膜'},
          // {name:'基础医学 -- 解剖学 -- 肝外胆到'},
          // {name:'基础医学 -- 解剖学 -- 滑膜关节的基本结构'},
          // {name:'基础医学 -- 解剖学 -- 泌尿系统'},
          // {name:'基础医学 -- 解剖学 -- 脑干的外形'},
          // {name:'基础医学 -- 解剖学 -- 消化腺'},
          // {name:'基础医学 -- 解剖学 -- 椎间盘'},
          // {name:'基础医学 -- 解剖学 -- 肺换气'},
          // {name:'基础医学 -- 解剖学 -- 肺换气'},
          // {name:'基础医学 -- 解剖学 -- 肺换气'},

          { name: "基础医学 -- 生理学" },
          { name: "基础医学 -- 病理学" },
          { name: "基础医学 -- 解剖学" },
          { name: "医学检验技术 -- 寄生虫检验" },
          { name: "医学检验技术 -- 免疫学检验" },
          { name: "医学检验技术 -- 生化检验" },
          { name: "医学检验技术 -- 微生物检验" },
          { name: "医学检验技术 -- 血液学检验" },
          { name: "医学检验技术 -- 临检基础" },
          { name: "医学检验技术 -- 临床输配血" },
          { name: "医学检验技术 -- 仪器结构展示" },
          { name: "医学检验技术 -- 原理动画" },
          { name: "医学检验技术 -- 实验操作" },
          { name: "医学检验技术 -- 线性" },
          { name: "药学 -- 药剂学" },
          { name: "药学 -- 有机化学" },
          { name: "药学 -- 天然化学" },
          { name: "药学 -- 药理学" },
          { name: "中医职业资格视频" },
        ];
        return true;
      }
      if (item.id == 6090) {
        this.currList = [];
        this.contentTxt = [{ name: "考试系统" }];
        return true;
      }
      if (item.id == 6115) {
        this.currList = [];
        this.contentTxt = [{ name: "切片系统" }];
        return true;
      }
      if (item.id == 56056) {
        this.currList = [];
        this.contentTxt = [{ name: "产品介绍" }];
        return true;
      }

      this.contentTxt = [];

      if (item.urlAddress == null || item.urlAddress == undefined) {
        this.getData(item.enCode);
      } else {
        if (item.coverImg.indexOf("http:") < 0) {
          item.coverImg = "http://" + window.location.host + item.coverImg;
        }

        //item.patentTitle = item.title;
        this.currList = [];
        this.currList.push(item);
      }
    },
  },
  mounted() {
    console.log(window.location.host);
    this.EnCode = this.config.StudentEnCode;
    this.id = this.$route.query.id;
    this.neirong1 = true;
    // this.getType();
    this.openmenu({ id: 3047, title: "临床血液形态学" });
  },
};
</script>



// WEBPACK FOOTER //
// src/view/curriculum.vue